import { viralWidgetSettingsSchema } from "@redotech/redo-conversion-core-common/viral/viral-widget";
import * as z from "zod";

export const viralWidgetRowSchema = viralWidgetSettingsSchema.extend({
  createdAt: z.coerce.date(),
});
export interface ViralWidgetRow extends z.infer<typeof viralWidgetRowSchema> {}

export const viralWidgetStateSchema = z.object({
  widget: viralWidgetRowSchema.nullable(),
  /** False when the team has no verified sending domain, which blocks enabling. */
  senderConfigured: z.boolean(),
});
export interface ViralWidgetState extends z.infer<
  typeof viralWidgetStateSchema
> {}

export const getViralWidget = {
  name: "getViralWidget" as const,
  description:
    "Returns the team's Thank You page viral widget config (null if never saved) plus whether a verified sending domain exists. Takes no input; team is derived from the session.",
  input: z.object({}),
  output: viralWidgetStateSchema,
};
